import React, { useEffect, useState } from "react";

/* Components */
import ConversionSummary from "../../../common/conversion/ConversionSummary";
import ConversionDetails from "../../../common/conversion/ConversionDetails";
import ConversionConfirmation from "../../../common/conversion/ConversionConfirmation";

export default function ConversionProductInterest({
    stepData,
    setStepData,
    doRequest,
    isLoading,
    closeModal,
    updateDataLayer
}) {
    /* Constants */
    const [totalStepData, setTotalStepData] = useState({});
    const { step1Data = {} } = totalStepData;

    useEffect(() => {
        const { step } = stepData;
        const newObject = { ...totalStepData, [`step${step}Data`]: stepData };

        setTotalStepData(newObject);
    }, [stepData]);

    /* DataLayer */
    useEffect(() => {
        if (stepData.step === 2) {
            updateDataLayer(stepData);
        }
    }, [stepData.step]);

    /* Render */
    return (
        <section className="pane pane--quaternary">
            <div className="container">
                <div className="row gutters-4 gutters-lg-6 gutters-xl-8">
                    <div className="col-12 col-lg-8 col-xl-6 offset-xl-1">
                        {stepData.step === 1 && typeof step1Data.inputs !== "undefined" && (
                            <form
                                onSubmit={(event) => {
                                    event.preventDefault();
                                    doRequest({ submit: 1 });
                                }}>
                                <ConversionDetails
                                    stepData={stepData}
                                    setStepData={setStepData}
                                    title="Offerte aanvragen"
                                    isLoading={isLoading}
                                />
                            </form>
                        )}
                        {stepData.step === 2 && (
                            <form onSubmit={(event) => {
                                event.preventDefault();
                                doRequest({ submit: 1 });
                            }}>
                                <ConversionConfirmation 
                                    stepData={stepData}
                                    closeModal={closeModal}
                                />
                            </form>
                        )}
                    </div>
                    <div className="col-12 col-lg-4 col-xl-3 offset-xl-1">
                        <ConversionSummary 
                            stepData={stepData}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
